import initConfig from './init-config'

export default function() {
  this.utils.widgetLoader.getAllWidgetInstances().forEach(function(widgetInstance) {
    widgetInstance.destroy()
  })

  this.config = initConfig()
  this.utils.widgetLoader.load()
}
